import {Helmet} from "react-helmet-async";
import {Card, CardContent, CardHeader, Container, Grid} from "@mui/material";
import React, {useEffect, useState} from "react";
import Box from "@mui/material/Box";
import {useNavigate} from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import {config} from "../constant";
import {joinWithLastWord} from '../utils/formatString';

export default function HomePage() {
    const [home, setHome] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        fetch(`${config.BASE_URL}/home`)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`${response.status} ${response.statusText}`)
                }
                return response.json();
            }).then(data => {
                setHome(data);
            }).catch(error => {
                const message = 'Erreur dans la récupération de la page d\'accueil';
                console.error(message, error);
                navigate("/error", {state: {message: message}});
            });
    }, []);

    return (
        <>
            <Helmet>
                <title>Accueil | Lose Awards</title>
            </Helmet>

            <Container maxWidth="false">
                {home ? (
                    <Grid container spacing={3}>
                        {/*Dernières nominations*/}
                        <Grid item xs={12} md={6} lg={8}>
                            <Card>
                                <CardHeader
                                    title="Dernières nominations"
                                    sx={{
                                        bgcolor: 'action.selected',
                                        p: '14px',
                                        '& .MuiCardHeader-title': {
                                            fontSize: '1rem'
                                        }
                                    }}
                                />
                                <CardContent>
                                    {home.nominations.map(nomination => (
                                        <Box key={nomination.id}>
                                            <b>{joinWithLastWord(nomination.nominees.map(nominee => nominee.firstName), ', ', 'et')}</b>
                                            &nbsp;dans la catégorie {nomination.category.name} ({nomination.reason})
                                        </Box>
                                    ))}
                                </CardContent>
                            </Card>
                        </Grid>

                        {/*Statistiques*/}
                        <Grid item xs={12} md={6} lg={4}>
                            <Card>
                                <CardHeader
                                    title="Statistiques"
                                    sx={{
                                        bgcolor: 'action.selected',
                                        p: '14px',
                                        '& .MuiCardHeader-title': {
                                            fontSize: '1rem'
                                        }
                                    }}
                                />
                                <CardContent>
                                    {home.stats.map(stat => (
                                        <Box key={stat.id}>
                                            {stat.firstName} a été nominé(e) {stat.nbNominations} fois
                                        </Box>
                                    ))}
                                    <Box>
                                        <b>Total :</b> {home.totalNominations}
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                ) : (
                    <Box display="flex" justifyContent="center" alignItems="center" minHeight="20vh">
                        <CircularProgress />
                    </Box>
                )}
            </Container>
        </>
    );
}